import React from 'react';

// Import actual hotel logos
import sommerroLogo from '../assets/hotel_logos/Sommerro.png';
import villaCopenhagenLogo from '../assets/hotel_logos/Villa-Copenhagen.png';
import farrisBadLogo from '../assets/hotel_logos/Farris-Bad.png';
import nordicLightLogo from '../assets/hotel_logos/Nordic-Light.png';
import sonSpaLogo from '../assets/hotel_logos/Son-Spa.png';
import hotelRivieraLogo from '../assets/hotel_logos/Hotel-Riviera.png';
import stromstadSpaResortLogo from '../assets/hotel_logos/Stromstad-Spa-Resort.png';
import stGeorgeLogo from '../assets/hotel_logos/st-george.png';
import atSixLogo from '../assets/hotel_logos/AtSix.png';
import amerikalinjenLogo from '../assets/hotel_logos/Amerikalinjen.png';

const hotelLogos = [
  { name: 'Sommerro', logo: sommerroLogo },
  { name: 'Villa Copenhagen', logo: villaCopenhagenLogo },
  { name: 'Farris Bad', logo: farrisBadLogo },
  { name: 'Nordic Light', logo: nordicLightLogo },
  { name: 'Son Spa', logo: sonSpaLogo },
  { name: 'Hotel Riviera', logo: hotelRivieraLogo },
  { name: 'Strömstad Spa Resort', logo: stromstadSpaResortLogo },
  { name: 'St. George', logo: stGeorgeLogo },
  { name: 'At Six', logo: atSixLogo },
  { name: 'Amerikalinjen', logo: amerikalinjenLogo },
];

export function HotelLogoCarousel() {
  return (
    <div className="py-16">
      <div className="max-w-6xl mx-auto px-6 mb-12">
        <div className="text-center">
          <h3 className="text-2xl font-display font-bold text-gray-900 mb-4">
            Where Scout is Making a Difference
          </h3>
          <p className="text-lg text-gray-600 font-text">
            Our custom AI assistants are enhancing guest experiences at these beautiful NHR hotels
          </p>
        </div>
      </div>
      
      {/* Infinite Carousel Container - Full Width */}
      <div className="relative overflow-hidden w-full max-w-7xl mx-auto">
        {/* Single row of logos with multiple duplicates for seamless loop */}
        <div 
          className="flex animate-scroll-left"
          style={{
            width: 'max-content'
          }}
        >
          {/* Multiple sets of logos for truly seamless loop */}
          {[...Array(4)].map((_, setIndex) => (
            <div key={`set-${setIndex}`} className="flex">
              {hotelLogos.map((hotel, index) => (
                <div key={`${setIndex}-${index}`} className="flex-shrink-0 mx-8">
                  <img 
                    src={hotel.logo} 
                    alt={`${hotel.name} logo`}
                    className="h-16 object-contain"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      target.nextElementSibling?.classList.remove('hidden');
                    }}
                  />
                  <span className="text-sm font-text font-semibold text-gray-700 hidden">
                    {hotel.name}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
